import React from 'react';

// Sports images imports
import championsLeagueSport from '../assets/sports/512rYUX2xarV.jpg'
import ligue1SportA from '../assets/sports/5CGjQgnyDO2f.jpg'
import tennisSport from '../assets/sports/9BfoSQlwAv7k.jpg'
import serieASportA from '../assets/sports/9bmyfObApgWi.webp'
import eredivisieSport from '../assets/sports/bFdo0Rm68y1r.jpeg'
import euro2024Sport from '../assets/sports/dY334gLQSUs3.jpg'
import motogpSport from '../assets/sports/htqK9bGsp4pe.jpg'
import laligaSport from '../assets/sports/IyidqtZcJKFh.jpeg'
import premierLeagueSport from '../assets/sports/MSBE1Ez2sY63.jpg'
import serieASportB from '../assets/sports/oFKhvss8oBJ7.webp'
import nascarSport from '../assets/sports/p5apiXaboZk6.jpg'
import f1SportA from '../assets/sports/qT0xgGPjjPIm.jpg'
import ligue1SportB from '../assets/sports/RYJmrmoLCkqa.jpeg'
import ufcSport from '../assets/sports/tGzAOEYf7zsk.jpg'
import euro2020Sport from '../assets/sports/up9AUM5UmJ7Z.jpeg'
import f1SportB from '../assets/sports/vAeogBTAMZ34.jpeg'

// League logos imports
import championsLeague from '../assets/league/Champions.svg'
import premierLeague from '../assets/league/Premier League.svg'
import laLiga from '../assets/league/Laliga.svg'
import serieA from '../assets/league/Seria A.svg'
import bundesliga from '../assets/league/Bundesliga.svg'
import ligue1svg from '../assets/league/ligue1svg.svg'
import ligue1webp from '../assets/league/Ligue_1.webp'
import europaLeague from '../assets/league/Europa League.png'
import uecl from '../assets/league/Uecl.png'
import eredivisieLeague from '../assets/league/Eredivisie.png'
import jupilerPro from '../assets/league/Jupiler Pro.svg'
import proLeague1B from '../assets/league/1B_Pro_League.png'
import ligaPortugal from '../assets/league/Ligaportugal.png'
import mls from '../assets/league/mls.png'
import nbaLeague from '../assets/league/NBA.png'
import nfl from '../assets/league/nfl.png'
import f1League from '../assets/league/f1.svg'
import rsl from '../assets/league/RSL.svg'
import worldCupLeague from '../assets/league/wc.png'

export default function Sports(){

    // League logos data
    const leagues = [
        { name: "Champions League", logo: championsLeague },
        { name: "Premier League", logo: premierLeague },
        { name: "LaLiga", logo: laLiga },
        { name: "Serie A", logo: serieA },
        { name: "Bundesliga", logo: bundesliga },
        { name: "Ligue 1", logo: ligue1svg },
        { name: "Ligue 1", logo: ligue1webp },
        { name: "Europa League", logo: europaLeague },
        { name: "UEFA Conference League", logo: uecl },
        { name: "Eredivisie", logo: eredivisieLeague },
        { name: "Jupiler Pro League", logo: jupilerPro },
        { name: "1B Pro League", logo: proLeague1B },
        { name: "Liga Portugal", logo: ligaPortugal },
        { name: "MLS", logo: mls },
        { name: "NBA", logo: nbaLeague },
        { name: "NFL", logo: nfl },
        { name: "F1", logo: f1League },
        { name: "RSL", logo: rsl },
        { name: "WK 2026", logo: worldCupLeague }
    ];

    // Sports events data
    const sportsEvents = [
        { id: 1, title: "Champions League", image: championsLeagueSport },
        { id: 2, title: "Ligue 1", image: ligue1SportA },
        { id: 3, title: "Tennis", image: tennisSport },
        { id: 4, title: "Serie A", image: serieASportA },
        { id: 5, title: "Eredivisie", image: eredivisieSport },
        { id: 6, title: "EK 2024", image: euro2024Sport },
        { id: 7, title: "MotoGP", image: motogpSport },
        { id: 8, title: "LaLiga", image: laligaSport },
        { id: 9, title: "Premier League", image: premierLeagueSport },
        { id: 10, title: "Serie A", image: serieASportB },
        { id: 11, title: "NASCAR", image: nascarSport },
        { id: 12, title: "F1", image: f1SportA },
        { id: 13, title: "Ligue 1", image: ligue1SportB },
        { id: 14, title: "UFC", image: ufcSport },
        { id: 15, title: "EK 2020", image: euro2020Sport },
        { id: 16, title: "F1", image: f1SportB }
    ];


    return(
        <>
        <section className="series-section relative overflow-hidden">
            {/* Background Pattern */}
            <div className="absolute inset-0 opacity-20">
                    <div className="h-64 w-full" style={{
                        backgroundImage: `radial-gradient(circle, #3b82f6 1px, transparent 1px)`,
                        backgroundSize: '20px 20px'
                    }}></div>
                </div>
            <div className="main-content w-[90%] sm:w-[90%] md:w-[85%] m-auto">
            <div className="text-center mt-12">
                <h1 className="text-2xl md:text-3xl lg:text-4xl mx-auto font-extrabold text-blue-900 mb-4 max-w-3xl leading-snug text-center">
                    Live sport en sportevenementen van over de hele wereld
                </h1>
                <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                    Geniet van de beste competities, wedstrijden en sportevenementen in HD/4K kwaliteit
                </p>
            </div>
            {/* Sports Events Carousel - Left to Right */}
            <div className="mt-5">
                <div className="relative overflow-hidden">
                    <div className="flex space-x-6 pb-5 carousel-sports">
                        {[...sportsEvents, ...sportsEvents, ...sportsEvents].map((event, index) => (
                            <div key={`${index}-${Math.random()}`} className="flex-shrink-0 carousel-item">
                                <div className="relative w-48 h-80 rounded-lg overflow-hidden shadow-lg">
                                    <img
                                        src={event.image}
                                        alt={event.title}
                                        className="w-full h-full object-cover carousel-image"
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            {/* Leagues Carousel - Right to Left */}
            <div className="mt-5">
                <div className="relative overflow-hidden">
                    <div className="flex space-x-8 carousel-leagues">
                        {[...leagues, ...leagues, ...leagues].map((league, index) => (
                            <div key={`${index}-${Math.random()}`} className="flex-shrink-0 flex items-center justify-center carousel-item">
                                <div className="w-24 h-16 flex items-center justify-center p-2">
                                    <img
                                        src={league.logo}
                                        alt={league.name}
                                        className="max-w-full max-h-full object-contain carousel-image"
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            </div>
        </section>
        </>
    )
}